import React, { forwardRef } from "react"
import { Dropdown } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import classes from "./TnSidebarLanguages.module.scss"

const TnSidebarLanguages = () => {
  const i18n = useTranslation()[1]

  const handleClick = (lang) => {
    localStorage.setItem("defaultLanguage", lang)

    i18n.changeLanguage(lang)
  }

  const dir =
    i18n.dir(i18n.language)

  return (
    <Dropdown className={classes["dropdown-button"]}>
      <Dropdown.Toggle
        as={forwardRef((props, ref) =>
          <button
            ref={ref}
            {...props}
            className={classes["button"]}
          >
            {i18n.language}
          </button>
        )}
      />

      <Dropdown.Menu
        align={dir === "rtl" ? "end" : "start"}
        style={{ margin: 0 }}
      >
        <Dropdown.Item
          className={classes["item"]}
          onClick={() => handleClick("fa")}
        >
          Farsi
        </Dropdown.Item>

        <Dropdown.Item
          className={classes["item"]}
          onClick={() => handleClick("en")}
        >
          English
        </Dropdown.Item>

        <Dropdown.Item
          className={classes["item"]}
          onClick={() => handleClick("ar")}
        >
          Arabic
        </Dropdown.Item>

        <Dropdown.Item
          className={classes["item"]}
          onClick={() => handleClick("tr")}
        >
          Turkish
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default TnSidebarLanguages